import { Controller } from 'react-hook-form';
import { Cell } from '@/shared/ui/Cell';
import { NumberFormat as NumberFormatComponent } from '@salutejs/sdds-insol';

type Props = {
    className?: string;
    decimalScale?: number;
    disabled?: boolean;
    label: string;
    maxLength?: number;
    name: string;
    size?: 'l' | 'm' | 's' | 'xl' | 'xs';
    onChange?: (value: string) => void;
};

export const NumberFormat = ({
    className,
    decimalScale = 2,
    maxLength,
    name,
    size = 'xl',
    disabled = false,
    label,
    onChange,
}: Props) => {
    return (
        <Controller
            render={({ field, fieldState }) => (
                <Cell className={className} error={fieldState.error?.message}>
                    <NumberFormatComponent
                        name={name}
                        size={size}
                        label={label}
                        disabled={disabled}
                        value={field.value}
                        decimalSeparator="."
                        maxLength={maxLength}
                        thousandSeparator=" "
                        labelPlacement="inner"
                        decimalScale={decimalScale}
                        fixedDecimalScale
                        onChange={(e) => {
                            field.onChange(e);
                            onChange?.(String(e));
                        }}
                    />
                </Cell>
            )}
            name={name}
        />
    );
};
